import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5500;
const GAP_MS = 12000;

/**
 * Notificación de baja frecuencia “alguien acaba de comprar”, abajo a la
 * izquierda para no tapar el CTA. Se puede cerrar y no vuelve en la sesión.
 * Datos de MUESTRA (data/recentPurchases.ts) — reemplazar antes de lanzar.
 */
export function PurchaseNotifications() {
  const reduceMotion = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timeout = setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      timeout = setTimeout(() => {
        setIndex(i => (i + 1) % recentPurchases.length);
        show();
      }, GAP_MS);
    };
    timeout = setTimeout(show, FIRST_DELAY);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  if (dismissed) return null;
  const purchase = recentPurchases[index];
  const minutes = 2 + index * 7 % 26;
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6" data-id="element-214" data-mp="ex03y2x46wza">
      <AnimatePresence data-id="element-215" data-mp="17jkyfc8vzp72">
        {visible && <motion.div key={index} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[320px] max-w-full items-start gap-3 rounded-xl border border-ice-dark bg-white p-3.5 shadow-card" data-id="element-216" data-mp="17kw096irumvj">
            <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-217" data-mp="3pqfaraqy8g75">
              <CheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-218" data-mp="3arl9nk6rfmwz" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-219" data-mp="3ftsqoo6g5t66">
              <p className="text-[13px] leading-snug text-ink" data-id="element-220" data-mp="3201f7a95nz7t">
                <span className="font-bold" data-id="element-221" data-mp="36r1cwhq3mlbd">{purchase.name}</span> in{' '}
                {purchase.city}, {purchase.state} just got Baseball Practice Ready
              </p>
              <p className="mt-1 text-[11px] font-bold uppercase tracking-wide text-ink-muted" data-id="element-222" data-mp="2s3ye87q1i6mg">
                {minutes} minutes ago · Verified order
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notifications" className="-mr-1 -mt-1 flex h-7 w-7 flex-none items-center justify-center rounded-full text-ink-muted transition-colors duration-150 hover:bg-ice hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-223" data-mp="2j1yyrjuobalm">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-224" data-mp="2dgpz4vtm1h57" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}